// extracted by mini-css-extract-plugin
export default {"reset":"ErrorBoundary_reset__4czaE"};